module.exports = __webpack_public_path__ + "img/footer-logo.f6887148.png";